import styled, { keyframes } from 'styled-components';

/* shimmer */
const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

const SkeletonBase = styled.div`
  background: linear-gradient(90deg, #e2e4e8 25%, #d6d9de 37%, #e2e4e8 63%);
  background-size: 400px 100%;
  animation: ${shimmer} 1.4s ease infinite;
  border-radius: 6px;
`;

/* Container */
export const PaymentContainer = styled.div`
  margin-top: 24px;
`;

/* Title */
export const TitleSkeleton = styled(SkeletonBase)`
  width: 160px;
  height: 24px;
  margin-bottom: 16px;
`;

/* Methods */
export const MethodsSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const MethodOption = styled(SkeletonBase)`
  height: 48px;
  border-radius: 8px;
`;

/* PIX / BOLETO box */
export const PixBoxSkeleton = styled.div`
  border: 2.3px dashed #d1d5db;
  border-radius: 8px;
  padding: 12px;
  margin-top: 12px;
  background: white;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const LineSkeleton = styled(SkeletonBase)`
  height: 14px;
  width: 80%;
`;

/* Card */
export const CardForm = styled.div`
  margin-top: 16px;
  padding: 20px;
  background: white;
  border-radius: 8px;
  border: 1px solid rgba(145, 158, 171, 0.2);
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const LabelSkeleton = styled(SkeletonBase)`
  width: 90px;
  height: 14px;
`;

export const InputSkeleton = styled(SkeletonBase)`
  width: 100%;
  height: 44px;
  border-radius: 8px;
`;

export const FieldRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

export const SmallInput = styled(SkeletonBase)`
  height: 44px;
  border-radius: 8px;
`;

/* Checkbox */
export const CheckboxRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CheckboxSkeleton = styled(SkeletonBase)`
  width: 16px;
  height: 16px;
  border-radius: 4px;
`;

export const TextSkeleton = styled(SkeletonBase)`
  width: 180px;
  height: 14px;
`;

/* Security note */
export const SecurityNoteSkeleton = styled(SkeletonBase)`
  width: 100%;
  height: 48px;
  border-radius: 6px;
`;
